export interface Link {
  link: string;
  caption: string;
  newWindow: boolean;
}

export interface IBanner {
  isEnabled: boolean;
  title: string;
  description: string;
  backgroundColour?: string;
  textColour?: string;
  link?: Link;
}
